/**
 * @generated SignedSource<<924cf5252d12788a529e70247a62a24f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CollectorTileContent_viewer$data = {
  readonly nftBenignNeglect: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"EndAuctionModal_viewer" | "NftItemTileTooltip_viewer" | "useMarketContext_viewer">;
  readonly " $fragmentType": "CollectorTileContent_viewer";
};
export type CollectorTileContent_viewer$key = {
  readonly " $data"?: CollectorTileContent_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CollectorTileContent_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CollectorTileContent_viewer",
  "selections": [
    {
      "alias": "nftBenignNeglect",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "nftBenignNeglect"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"nftBenignNeglect\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EndAuctionModal_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useMarketContext_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftItemTileTooltip_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "c4211da12293b8b0a6fbfd0ec42f1da1";

export default node;
